import React, { Component } from 'react';

export class Thumbnail extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    let { page, item, doneDrawing } = this.props;
    let canvas = this.canvasRef.current;
    let vp = page.getViewport({ scale: 1 });
    if (vp.width > 300) {
      let newScale = 300 / vp.width;
      vp = page.getViewport({ scale: newScale });
    }
    canvas.height = vp.height;
    canvas.width = vp.width;
    page
      .render({
        canvasContext: canvas.getContext('2d'),
        viewport: vp
      })
      .promise.then(() => {
        doneDrawing(item);
      });
  }

  render() {
    return <canvas id={`canvas_${this.props.item}`} ref={this.canvasRef} />;
  }
}

export default Thumbnail;
